module.exports = __webpack_public_path__ + "img/2018-09-7.b20d8cc9.jpeg";